import { useStoreDollHouseMap } from "../../store";
import { useEffect, useState } from "react";
import {
  animationStart,
  animationEnd,
  showPopupWithContent,
  hidePopup,
} from "../../components/customEvents.js";
import { shallow } from "zustand/shallow";

export default function VdaraHotspots() {
  const [destvinolyActive, setdestvinolyActive] = useState("");
  const [destsilkroadActive, setdestsilkroadActive] = useState("");
  const [sourcevinolyActive, setsourcevinolyActive] = useState("");
  const [sourcesilkroadActive, setsourcesilkroadActive] = useState("");
  const [restaurentActive, setrestaurentActive] = useState("");
  const [conventionActive, setconventionActive] = useState("");

  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      sourcePoidSelected: state.sourcePoidSelected,
      destinationPoidSelected: state.destinationPoidSelected,
      VdaraHighlightPoiStore: state.VdaraHighlightPoiStore,
      resetVdaraHighlightPOI: state.resetVdaraHighlightPOI,
    }),
    shallow
  );

  /*
   * VDARA  EXIST Route POI HIGHLIGHTING [start]
   */

  // useEffect(() => {
  //   if (dollhouseStore.sourcePoidSelected === "") {
  //     setsourcevinolyActive("");
  //     setsourcesilkroadActive("");
  //   }

  //   if (dollhouseStore.sourcePoidSelected === "vdara_vinoly") {
  //     setsourcevinolyActive("active-poi-selection");
  //   }
  //   if (dollhouseStore.sourcePoidSelected === "vdara_silkroad") {
  //     setsourcesilkroadActive("active-poi-selection");
  //   }
  // }, [dollhouseStore.sourcePoidSelected]);

  // useEffect(() => {
  //   if (dollhouseStore.destinationPoidSelected === "") {
  //     setdestvinolyActive("");
  //     setdestsilkroadActive("");
  //   }

  //   if (dollhouseStore.destinationPoidSelected === "vdara_vinoly") {
  //     setdestvinolyActive("active-poi-selection");
  //   }
  //   if (dollhouseStore.destinationPoidSelected === "vdara_silkroad") {
  //     setdestsilkroadActive("active-poi-selection");
  //   }
  // }, [dollhouseStore.destinationPoidSelected]);

  /*
   * VDARA  EXIST Route POI HIGHLIGHTING [end]
   */

  /*
   * VDARA  NOT EXIST Route POI HIGHLIGHTING [start]
   */

  useEffect(() => {
    document.querySelectorAll(".poi-hover").forEach((val) => {
      val.classList.remove("active-poi");
    });

    setrestaurentActive("");
    setconventionActive("");

    if (dollhouseStore.VdaraHighlightPoiStore === "vdara_restaurent") {
      setrestaurentActive("active-poi");
    } else if (dollhouseStore.VdaraHighlightPoiStore === "vdara_vinoly") {
      setconventionActive("active-poi");
    } else {
      if (document.getElementById(dollhouseStore.VdaraHighlightPoiStore)) {
        document
          .getElementById(dollhouseStore.VdaraHighlightPoiStore)
          .classList.add("active-poi");
      }
    }
  }, [dollhouseStore.VdaraHighlightPoiStore]);

  /*
   * VDARA  NOT EXIST Route POI HIGHLIGHTING [ends]
   */
  return (
    <>
      <g transform="translate(3295.082 1100.811)">
        {/* <path
          d="M-3048-11814.584l83.492,11.85-.32,3.713-13.71,5.9-15.551,6.708-9.073,3.757-49.156-9.693Z"
          transform="translate(3356.602 12263.765)"
          className="poi-hover"
          id="vdara_connection_bellagio"
          fill="rgba(255,255,255,0.06)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "vdara_connection_bellagio");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("vdara_connection_bellagio");
            showPopupWithContent(e, "vdara_connection_bellagio");
          }}
          onMouseLeave={(e) => {
            animationEnd("vdara_connection_bellagio");
            hidePopup("vdara_connection_bellagio");
            dollhouseStore.resetVdaraHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("vdara_connection_bellagio");
            dollhouseStore.resetVdaraHighlightPOI("");
          }}
        /> */}

        <path
          className="poi-hover"
          id="vdara_registeration"
          d="M-5714-12844.05l37.126,1.556,4.851-18.467,11-44.318,14.864-68.344,1.555-9.214,54.408,1.62,2.095-69.288v-14.686l7.43-1.353-1.9-8.831-15.678,2.3v16.563l-14.7,1.047-1.153-13.042-7.22.781-8.44-42.47-5.015-26.905-25.718,6.13-2-10.458-19.652-10.859h-16.279l-16.279-1.15-15.933,45.36,6.546,6.219,6.841,3.273,8.313,5.368,9.229,5.957,9.819,9.982,7.168,8.771,5.335,10.866,6.546,15.775,2.389,16.2v21.251l-3.862,16.519-8.346,14.271-12.344,14.5-8.164,13.606-10.3,24.3-5.782,13.055-4.325,4.829,5.442,26.047Z"
          transform="translate(5788.918 13311.189)"
          fill="rgba(255,255,255,0.07)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "vdara_registeration");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("vdara_registeration");
            showPopupWithContent(e, "vdara_registeration");
          }}
          onMouseLeave={(e) => {
            animationEnd("vdara_registeration");
            hidePopup("vdara_registeration");
            dollhouseStore.resetVdaraHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("vdara_registeration");
            dollhouseStore.resetVdaraHighlightPOI("");
          }}
        />

        <path
          className="poi-hover"
          id="vdara_guest_elevators"
          d="M-3219.485-12153.881l38.029-3.367,1.619,18.189.78,20.85v14.576l-.83,21.459-1.654,18.648-42.408-3.322v-3.494h-3.35l1.516-12.6.858-13.793v-20.344l-.869-27.553-.988-10.908h7.3Z"
          transform="translate(3427.165 12401.945)"
          fill="rgba(255,255,255,0.04)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "vdara_guest_elevators");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("vdara_guest_elevators");
            showPopupWithContent(e, "vdara_guest_elevators");
          }}
          onMouseLeave={(e) => {
            animationEnd("vdara_guest_elevators");
            hidePopup("vdara_guest_elevators");
            dollhouseStore.resetVdaraHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("vdara_guest_elevators");
            dollhouseStore.resetVdaraHighlightPOI("");
          }}
        />

        {/* <g
          id="vdara_vinoly"
          className={`poi-hover  ${conventionActive} `}
          fill="rgba(255,255,255,0)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "vdara_vinoly");
            setconventionActive("active-poi");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("vdara_vinoly");
            showPopupWithContent(e, "vdara_vinoly");
            setconventionActive("active-poi");
          }}
          onMouseLeave={(e) => {
            animationEnd("vdara_vinoly");
            hidePopup("vdara_vinoly");
            setconventionActive("");
            dollhouseStore.resetVdaraHighlightPOI("");
          }}
          transform="translate(5.339 3.467)"
        >
          <path
            id="Path_2045"
            data-name="Path 2045"
            d="M-3454.145-12557.68l73.149.295v4.068h39.543l9.225-5.479,5.578,9.365,24.586-12.062,6.28,8.852,10.732-6.56h36.189l41.791,100.565v17.793l-67.014,19.969-1.64-4.576-14.628,3.621-2.688-7.265,2.688-.784-6.771-24.431-6.982-18.45-5.531-10.338-26.3,11.918,2.154,26.687-12.5,3.3-.2-21.606H-3374.3l-1.116,18.138-78.6.141Z"
            transform="translate(3513.303 12561.493)"
          />
        </g> */}

        <g
          id="vdara_vinoly"
          className={`poi-hover  ${conventionActive} `}
          fill="rgba(255,255,255,0)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "vdara_vinoly");
            setconventionActive("active-poi");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("vdara_vinoly");
            showPopupWithContent(e, "vdara_vinoly");
            setconventionActive("active-poi");
          }}
          onMouseLeave={(e) => {
            animationEnd("vdara_vinoly");
            hidePopup("vdara_vinoly");
            setconventionActive("");
            dollhouseStore.resetVdaraHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("vdara_vinoly");
            setconventionActive("");
            dollhouseStore.resetVdaraHighlightPOI("");
          }}
          transform="translate(5.339 3.467)"
        >
          <path
            id="Path_2045"
            data-name="Path 2045"
            d="M-3454.145-12557.68l73.149.295v4.068h39.543l9.225-5.479,5.578,9.365,24.586-12.062,6.28,8.852,10.732-6.56h36.189l41.791,100.565v17.793l-67.014,19.969-1.64-4.576-14.628,3.621-2.688-7.265,2.688-.784-6.771-24.431-6.982-18.45-5.531-10.338-26.3,11.918,2.154,26.687-12.5,3.3-.2-21.606H-3374.3l-1.116,18.138-78.6.141Z"
            transform="translate(3513.303 12561.493)"
          />
          <path
            id="Path_2046"
            data-name="Path 2046"
            d="M-3484.851-11777.082h41.3l-6.353,22.26,39.512,16.926,1.447-2.771,16.243-31.265,28.549,11.684-17.594,35.437-29.353-12.535-83.088,145.082h-59.094l20.214-31.562,20.168-33.557,14.83-28.955-5.818-4.281,20-24.573,11.179-16.39,8.724-14.111-20.271-13.213Z"
            transform="translate(3553.28 12245.175)"
          />
          <path
            id="Path_2145"
            data-name="Path 2145"
            d="M112.448,156.636c.664-.019,6.463-1.158,6.463-1.158s4.016-1.033,6.36-1.867,1.089-.557,3.014-1.468,4.687-2.177,4.687-2.177l5.214-2.716a4.471,4.471,0,0,0,2.808-1.766,8.919,8.919,0,0,0,.836-4.067V135.48H109.743s-.467,18.674,0,20S111.785,156.654,112.448,156.636Z"
            transform="translate(-5.339 -3.468)"
          />
        </g>

        <g
          id="vdara_restaurent_1"
          className={`poi-hover ${restaurentActive}`}
          fill="rgba(255,255,255,0.06)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "vdara_restaurent_1");
            setrestaurentActive("");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("vdara_restaurent_1");
            showPopupWithContent(e, "vdara_restaurent_1");
            setrestaurentActive("active-poi");
          }}
          onMouseLeave={(e) => {
            animationEnd("vdara_restaurent_1");
            hidePopup("vdara_restaurent_1");
            setrestaurentActive("");
            dollhouseStore.resetVdaraHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("vdara_restaurent_1");
            setrestaurentActive("");
            dollhouseStore.resetVdaraHighlightPOI("");
          }}
        >
          <path
            id="vdara-vice-versa"
            d="M-3473.817-12222.9l27.575,16.674,13.435,12.352,10.761,15.379,6.736,16.3,3.452,14.658,1.282,17.945-3.492,19.727-4.385,9.785-6.536,10.891-11,13.717-7.9,13.059-7.605,17.232-8.189,19.688-6.736.914-18.2-55.314,8.252-2.889-9.044-27.092-2.973-18.609v-18.707l1.668-11.463,1.329-6.766,2.287-11.119,4.072-15.723-7.086-2.449Z"
            transform="translate(3532.448 12428.418)"
          />
          <g id="vdara-restaurants" transform="translate(108.506 329.232)">
            <path
              id="Path_2047"
              data-name="Path 2047"
              d="M-3333.673-12015.589l33.814,2.248h12.181l-19.165,111.227-50.111-15.345,6.577-18.336,6.786-25.979,6.072-30.211Z"
              transform="translate(3370.944 12015.589)"
            />
            <path
              id="Path_2048"
              data-name="Path 2048"
              d="M-3369.986-11800.694l47.231,19.077-18.37,34.228-39.272-17.06Z"
              transform="translate(3380.397 11928.931)"
            />
          </g>
        </g>

        <path
          className="poi-hover"
          id="vdara_walkway_to_aria"
          d="M-3529.852-11695.213l37.752,15.293-19.238,23.023,6.257,5.318-13.6,27.347-6.833,10.628-26.854-13.765,8.144-15.639,11.728-34.12Z"
          transform="translate(3558.25 12215.627)"
          fill="rgba(255,255,255,0.04)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "vdara_walkway_to_aria");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("vdara_walkway_to_aria");
            showPopupWithContent(e, "vdara_walkway_to_aria");
          }}
          onMouseLeave={(e) => {
            animationEnd("vdara_walkway_to_aria");
            hidePopup("vdara_walkway_to_aria");
            dollhouseStore.resetVdaraHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("vdara_walkway_to_aria");
            dollhouseStore.resetVdaraHighlightPOI("");
          }}
        />
      </g>
    </>
  );
}
